/**
 * @generated SignedSource<<dd5305794ec01c0ead1b13d8ba1fdd13>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type WidgetTodoOverviewDisplayMode = "MEDIUM" | "MEDIUM_GROUPED";
export type PreviewWidgetTodoCategoryOverviewInput = {
  categoryId: string;
  displayMode?: WidgetTodoOverviewDisplayMode | null;
  size: WidgetOverviewSize;
  storecastId?: string | null;
  teamIds?: ReadonlyArray<string> | null;
};
export type WidgetTodoOverviewPreviewQuery$variables = {
  after?: string | null;
  first?: number | null;
  input: PreviewWidgetTodoCategoryOverviewInput;
  storecastId: string;
};
export type WidgetTodoOverviewPreviewQuery$data = {
  readonly dashboard: {
    readonly previewWidgetTodoCategoryOverview: {
      readonly " $fragmentSpreads": FragmentRefs<"WidgetTodoOverviewPreview_widget">;
    };
  } | null;
};
export type WidgetTodoOverviewPreviewQuery = {
  response: WidgetTodoOverviewPreviewQuery$data;
  variables: WidgetTodoOverviewPreviewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "storecastId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "storecastId"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v8 = [
  (v6/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requiredToDescribeTodo",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUri",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ordinal",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isIssue",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoSubject",
  "kind": "LinkedField",
  "name": "subject",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoSubjectBreadcrumb",
      "kind": "LinkedField",
      "name": "allBreadcrumbs",
      "plural": true,
      "selections": [
        (v7/*: any*/),
        (v10/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isRoot",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v11/*: any*/),
    (v12/*: any*/)
  ],
  "storageKey": null
},
v17 = [
  (v9/*: any*/),
  (v6/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "TodoCategoryTag",
  "kind": "LinkedField",
  "name": "tags",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expireAt",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "expireAtFormatted",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedRole",
  "kind": "LinkedField",
  "name": "assignedRoles",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "EmployeeRole",
      "kind": "LinkedField",
      "name": "role",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Employee",
          "kind": "LinkedField",
          "name": "employees",
          "plural": true,
          "selections": [
            (v6/*: any*/),
            (v21/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLinkedToViewer",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "workStatus",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "concreteType": "Todo",
  "kind": "LinkedField",
  "name": "subTodos",
  "plural": true,
  "selections": [
    (v14/*: any*/),
    (v9/*: any*/),
    (v6/*: any*/)
  ],
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignedEmployee",
  "kind": "LinkedField",
  "name": "assigned",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        (v21/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    (v6/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "commentCount",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canWrite",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priority",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isResponseCompleted",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "response",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "images",
          "plural": true,
          "selections": [
            (v6/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "thumbhash",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ImageSize",
              "kind": "LinkedField",
              "name": "sizes",
              "plural": true,
              "selections": [
                (v6/*: any*/),
                (v29/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "urlExpiresAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "height",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "width",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "TodoResponseImage",
      "abstractKey": null
    }
  ],
  "storageKey": null
},
v31 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "WidgetTodoOverviewPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "WidgetTodoOverview",
            "kind": "LinkedField",
            "name": "previewWidgetTodoCategoryOverview",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "WidgetTodoOverviewPreview_widget"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "WidgetTodoOverviewPreviewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Dashboard",
        "kind": "LinkedField",
        "name": "dashboard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "WidgetTodoOverview",
            "kind": "LinkedField",
            "name": "previewWidgetTodoCategoryOverview",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TodoCategory",
                "kind": "LinkedField",
                "name": "category",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Team",
                "kind": "LinkedField",
                "name": "teams",
                "plural": true,
                "selections": (v8/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v6/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "subscriptionKey",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TodoSubjectGroup",
                        "kind": "LinkedField",
                        "name": "subjectGroups",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TodoSubject",
                            "kind": "LinkedField",
                            "name": "subject",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "TodoSubjectBreadcrumb",
                                "kind": "LinkedField",
                                "name": "allBreadcrumbs",
                                "plural": true,
                                "selections": [
                                  (v7/*: any*/),
                                  (v10/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v11/*: any*/),
                              (v12/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Todo",
                            "kind": "LinkedField",
                            "name": "todos",
                            "plural": true,
                            "selections": [
                              (v6/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v7/*: any*/),
                              (v15/*: any*/),
                              (v16/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Image",
                                "kind": "LinkedField",
                                "name": "images",
                                "plural": true,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "File",
                                "kind": "LinkedField",
                                "name": "files",
                                "plural": true,
                                "selections": (v17/*: any*/),
                                "storageKey": null
                              },
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              (v22/*: any*/),
                              (v23/*: any*/),
                              (v24/*: any*/),
                              (v25/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/),
                              (v28/*: any*/),
                              (v30/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "WidgetTodoOverviewContentMediumGrouped",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "todoContent",
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "content",
                "plural": false,
                "selections": [
                  (v9/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v31/*: any*/),
                        "concreteType": "TodoConnection",
                        "kind": "LinkedField",
                        "name": "todos",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TodoEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Todo",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "formattedBody",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "body",
                                    "storageKey": null
                                  },
                                  (v15/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoreZonedDate",
                                    "kind": "LinkedField",
                                    "name": "createdAtDate",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "style",
                                            "value": "DEFAULT"
                                          }
                                        ],
                                        "kind": "ScalarField",
                                        "name": "storeFormattedDate",
                                        "storageKey": "storeFormattedDate(style:\"DEFAULT\")"
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v16/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "minHeight",
                                            "value": 699
                                          },
                                          {
                                            "kind": "Literal",
                                            "name": "minWidth",
                                            "value": 699
                                          }
                                        ],
                                        "concreteType": "ImageSize",
                                        "kind": "LinkedField",
                                        "name": "size",
                                        "plural": false,
                                        "selections": [
                                          (v29/*: any*/),
                                          (v6/*: any*/)
                                        ],
                                        "storageKey": "size(minHeight:699,minWidth:699)"
                                      },
                                      (v6/*: any*/),
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "StoreProduct",
                                    "kind": "LinkedField",
                                    "name": "linkedProducts",
                                    "plural": true,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v21/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "partNumber",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "imageUrl",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "File",
                                    "kind": "LinkedField",
                                    "name": "files",
                                    "plural": true,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v21/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "formattedSize",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "type",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FilePage",
                                        "kind": "LinkedField",
                                        "name": "pages",
                                        "plural": true,
                                        "selections": (v8/*: any*/),
                                        "storageKey": null
                                      },
                                      (v9/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v30/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__id",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": (v31/*: any*/),
                        "filters": null,
                        "handle": "connection",
                        "key": "WidgetTodoOverviewContentMedium__todos",
                        "kind": "LinkedHandle",
                        "name": "todos"
                      }
                    ],
                    "type": "WidgetTodoOverviewContentMedium",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v8/*: any*/),
                    "type": "WidgetTodoOverviewContentMediumGrouped",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a5eb228ec564f49ec9f571bbe4ce99fa",
    "id": null,
    "metadata": {},
    "name": "WidgetTodoOverviewPreviewQuery",
    "operationKind": "query",
    "text": "query WidgetTodoOverviewPreviewQuery(\n  $input: PreviewWidgetTodoCategoryOverviewInput!\n  $first: Int\n  $after: String\n  $storecastId: ID!\n) {\n  dashboard(id: $storecastId) {\n    previewWidgetTodoCategoryOverview(input: $input) {\n      ...WidgetTodoOverviewPreview_widget\n      id\n    }\n    id\n  }\n}\n\nfragment Image_image on Image {\n  id\n  thumbhash\n  sizes {\n    id\n    url\n    urlExpiresAt\n    height\n    width\n  }\n}\n\nfragment LinkedProducts_products on StoreProduct {\n  id\n  name\n  partNumber\n  imageUrl\n}\n\nfragment SignalDetailFiles_files on File {\n  id\n  name\n  formattedSize\n  type\n  pages {\n    id\n  }\n}\n\nfragment StoreFormattedDate on StoreZonedDate {\n  storeFormattedDate(style: DEFAULT)\n}\n\nfragment TodoDetailContentMain_todo on Todo {\n  id\n  title\n  formattedBody\n  body\n  isIssue\n  ...TodoEditNewMainCreationInfo\n  ...TodoDetailImages_todo\n  linkedProducts {\n    ...LinkedProducts_products\n    id\n  }\n  files {\n    ...SignalDetailFiles_files\n    id\n  }\n}\n\nfragment TodoDetailImages_todo on Todo {\n  images {\n    size(minHeight: 699, minWidth: 699) {\n      url\n      id\n    }\n    id\n  }\n}\n\nfragment TodoEditNewMainCreationInfo on Todo {\n  createdAtDate {\n    ...StoreFormattedDate\n  }\n  subject {\n    ...TodoSubject_TodoSubject\n  }\n}\n\nfragment TodoOverviewListItemMediumDescription_Todo on Todo {\n  title\n  isIssue\n  subject {\n    ...TodoSubject_TodoSubject\n    ...TodoSubjectExcludeRoot_TodoSubject\n  }\n  images {\n    __typename\n    id\n  }\n  files {\n    __typename\n    id\n  }\n}\n\nfragment TodoOverviewListItemMediumFooter_Todo on Todo {\n  tags {\n    id\n    color\n    title\n  }\n  ...WidgetTodoListItemDeadline_todo\n  expireAt\n  assignedRoles {\n    role {\n      name\n      employees {\n        id\n        name\n        isLinkedToViewer\n        workStatus\n      }\n      id\n    }\n    id\n  }\n  subTodos {\n    status\n    __typename\n    id\n  }\n  assigned {\n    employee {\n      name\n      id\n    }\n    id\n  }\n  commentCount\n}\n\nfragment TodoOverviewListItemMediumStatusAndPrio_Todo on Todo {\n  canWrite\n  id\n  status\n  priority\n  expireAt\n  isResponseCompleted\n  ordinal\n  response {\n    __typename\n    ... on TodoResponseNumber {\n      __typename\n    }\n    ... on TodoResponseText {\n      __typename\n    }\n    ... on TodoResponseImage {\n      __typename\n      images {\n        id\n        ...Image_image\n      }\n    }\n  }\n}\n\nfragment TodoOverviewListItemMedium_Todo on Todo {\n  id\n  ...TodoOverviewListItemMediumDescription_Todo\n  ...TodoOverviewListItemMediumFooter_Todo\n  ...TodoOverviewListItemMediumStatusAndPrio_Todo\n}\n\nfragment TodoSubjectExcludeRoot_TodoSubject on TodoSubject {\n  allBreadcrumbs {\n    title\n    isRoot\n    requiredToDescribeTodo\n  }\n}\n\nfragment TodoSubjectIcon_TodoSubject on TodoSubject {\n  icon\n  iconUri\n}\n\nfragment TodoSubject_TodoSubject on TodoSubject {\n  allBreadcrumbs {\n    title\n    requiredToDescribeTodo\n  }\n  ...TodoSubjectIcon_TodoSubject\n}\n\nfragment WidgetTodoListItemDeadline_todo on Todo {\n  expireAt\n  expireAtFormatted\n}\n\nfragment WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped on WidgetTodoOverviewContentMediumGrouped {\n  __typename\n  id\n  subscriptionKey\n  subjectGroups {\n    subject {\n      ...TodoSubject_TodoSubject\n    }\n    todos {\n      id\n      ordinal\n      status\n      ...TodoOverviewListItemMedium_Todo\n    }\n  }\n}\n\nfragment WidgetTodoOverviewContentMediumPaginated on WidgetTodoOverview {\n  teams {\n    id\n  }\n  category {\n    id\n  }\n  todoContent: content {\n    __typename\n    ... on WidgetTodoOverviewContentMedium {\n      todos(first: $first, after: $after) {\n        edges {\n          node {\n            id\n            ordinal\n            status\n            ...TodoDetailContentMain_todo\n            ...TodoOverviewListItemMedium_Todo\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          endCursor\n          hasNextPage\n        }\n      }\n    }\n    ... on WidgetTodoOverviewContentMediumGrouped {\n      id\n    }\n  }\n  id\n}\n\nfragment WidgetTodoOverviewPreview_widget on WidgetTodoOverview {\n  id\n  title\n  category {\n    id\n    title\n  }\n  teams {\n    id\n  }\n  content {\n    __typename\n    ... on WidgetTodoOverviewContentMediumGrouped {\n      __typename\n      ...WidgetTodoOverviewContentMediumGrouped_WidgetTodoOverviewContentMediumGrouped\n      id\n    }\n    ... on WidgetTodoOverviewContentMedium {\n      __typename\n    }\n  }\n  ...WidgetTodoOverviewContentMediumPaginated\n}\n"
  }
};
})();

(node as any).hash = "bf7ac9b7ce707e3e233b47a8f7ec269d";

export default node;
